import React from 'react';

type QuantityInputProps = {
  value: string | number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
};

const QuantityInput: React.FC<QuantityInputProps> = ({
  value,
  onChange,
  min = 0,
  max = Infinity,
  disabled,
}) => {
  const handleIncrement = () => {
    if (typeof value === 'number' && value < max && !disabled) {
      onChange(value + 1);
    }
  };

  const handleDecrement = () => {
    if (typeof value === 'number' && value > min && !disabled) {
      onChange(value - 1);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = parseInt(e.target.value, 10);
    if (!isNaN(inputValue) && inputValue >= min) {
      if (inputValue >= max) onChange(max);
      else onChange(inputValue);
    }
  };

  return (
    <div className="ticket-input small form-control ticket-group input-group">
      {!disabled && (
        <button type="button" className="quantity-input input-group-text" onClick={handleDecrement}>
          -
        </button>
      )}
      <input
        value={`${value}${value === 999 ? '+' : ''}`}
        onChange={handleChange}
        className="quantity-input-text form-control"
        disabled={disabled}
      />
      {!disabled && (
        <button type="button" className="quantity-input input-group-text" onClick={handleIncrement}>
          +
        </button>
      )}
    </div>
  );
};

export default QuantityInput;
